class ApiService {
  _apiUrl = 'https://api-neto.herokuapp.com/bosa-noga';

  fetchData = async (urlEntity, options = {method: "GET"}) => {
    const res = await fetch(`${this._apiUrl}${urlEntity}`, options);

    if (!res.ok) {
      throw new Error(`Could not fetch ${urlEntity}, status - ${res.status}`)
    }
    return await res.json();
  };

  getFeatured = async () => {
    return await this.fetchData(`/featured`);
  };

  getFilters = async () => {
    return await this.fetchData(`/filters`);
  };

  getCategories = async () => {
    return await this.fetchData(`/categories`);
  };

  getProducts = async (params) => {
    return await this.fetchData(`/products?${params}`);
  };

  getProduct = async (params) => {
    return await this.fetchData(`/products/${params}`);
  };

  getCart = async (cartId) => {
    return await this.fetchData(`/cart/${cartId}`);
  };

  setCart = async (params, data) => {
    return await this.fetchData(
      `/cart/${params}`,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {'content-type': 'application/json'}
      }
    );
  };

  setOrder = async (data) => {
    return await this.fetchData(
      `/order`,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {'content-type': 'application/json'}
      }
    );
  };
}

export default ApiService

